/**
 * @deprecated Use `Modal` from `components/ui/Modal` for new code. Prefer
 * `ModalContent` for scrollable body layout instead of baking overflow into the shell.
 * Migrate existing usages in a follow-up PR.
 */
interface WrapperProps {
  readonly children: React.ReactNode;
  readonly mainStyles?: string;
  readonly additionalStyles?: string;
}

export default function ModalWrapper({
  children,
  additionalStyles = '~gap-3/6',
  mainStyles = 'relative top-1/2 -translate-y-1/2 w-[90%] sm:w-[80%] md:w-[75%] xl:w-[55%] h-fit max-h-[90vh] overflow-y-auto scrollbar-thin scrollbar-track-orange-100 scrollbar-thumb-orange-300 flex flex-col items-center border-2 border-primary-500 rounded-lg ~p-2/4 shadow-[4px_4px_0px_0px_rgba(0,0,0,0.2)] mx-auto animate-fadeIn'
}: WrapperProps) {
  return (
    <div
      className={`${mainStyles} dark:bg-secondary-dark-200 bg-white ${additionalStyles}`}
      data-testid='modal-wrapper'>
      {children}
    </div>
  );
}
